module.exports = __webpack_public_path__ + "static/img/3.c8a4a108.png";